'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".RefreshIcon-module_refreshIconSpin__pqvv0{animation:RefreshIcon-module_spin__xYGFD .75s linear infinite}@keyframes RefreshIcon-module_spin__xYGFD{0%{transform:rotate(0deg)}to{transform:rotate(-1turn)}}";
var styles = {"refreshIconSpin":"RefreshIcon-module_refreshIconSpin__pqvv0","spin":"RefreshIcon-module_spin__xYGFD"};
styleInject["default"](css_248z, '238a93be-0820-4fce-9bc9-05a562f50a09');

exports["default"] = styles;
